import React from 'react';
import {Document} from '.';
import {Section} from '../Section';

interface DocumentsSectionProps {
	documents: {label: string; uri: string}[];
}

export function DocumentsSection({documents}: DocumentsSectionProps): React.ReactElement {
	return (
		<Section title="Документы" count={documents.length}>
			<div className="grid gap-2.5">
				{documents.map((document) => (
					<Document key={document.label} title={document.label} url={document.uri} />
				))}
			</div>
		</Section>
	);
}
